import React, { useState, useRef } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import { useFetch } from '../utilities/useFetch';
import { Toast } from 'primereact/toast';
import axios from "axios";
import { ROL_SUPERADMIN, ROL_PERFIL_ADMINISTRADOR } from '../constants/roles';

export const Login = (props) => {
    const toast = useRef(null);
    const anioActual = new Date().getFullYear();
    const navigate = useNavigate();
    const [form, setForm] = useState({});
    const HOST_API = process.env.REACT_APP_URL;

    function HandleClick(e) {
        e.preventDefault();
        handleLogin();
      }
      function HandleClickEnter(e) {
        e.preventDefault();

        if (e.keyCode === 13) {
          handleLogin();
        }
      }

      function load()
      {
        const requestOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        };

        const body={
            userName: form.user,
            password: form.password
        }

        if (body.userName == '' || body.userName == undefined){
          alert('Completar usuario')
          return;
        }
        if (body.password == '' || body.password == undefined){
          alert('Completar password')
          return;
        }

        console.log(requestOptions)

        const url = `${ HOST_API }api/users/authenticate`;
        console.log("url", url);
        console.log("body", body);

        axios.post(url, body, requestOptions)
        .then( (data)=> {
          console.log(data.data);
          showSuccess('Login', 'Usuario loguardo OK.')
          //data.request;

          localStorage.setItem("user", JSON.stringify(data));
          navigate("/");
        })
        .catch ( (error) => {
          alert(error.response.data.message);
          return;
        })

      }

      const showSuccess = (titulo, mensaje) => {
        toast.current.show({ severity: 'success', summary: titulo, detail: mensaje, life: 3000 });
      };

      function load3(){
        if (form.user === '' || form.user === undefined){
          alert('Completar usuario')
          alert('Completar usuario')
          return;
        }
        if (form.password === '' || form.password === undefined){
          alert('Completar password')
          alert('Completar password')
          return;
        }

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        var urlencoded = new URLSearchParams();
        urlencoded.append("Email", form.user);
        urlencoded.append("Contrasenia", form.password);

        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: urlencoded,
          redirect: 'follow'
        };

        fetch("https://be.districtmanager.com.ar/api/Login/post", requestOptions)
          .then(response => response.json())
          .then(
            result => {
              localStorage.setItem("user", JSON.stringify(result));
              navigate("/");
            }
          )
          .catch(error => {
            console.log('error', error);
            alert(error);
        });
      }
      
      const handleLogin = async () => {

        const body = {
            userName: form.user,
            password: form.password
        };

        if (!body.userName) { alert('Completar usuario');  return; }
        if (!body.password) { alert('Completar password'); return; }

        try {
          const url = `${HOST_API}api/usersAdm/authenticate`;
          const response = await axios.post(url, body, {
              headers: { 'Content-Type': 'application/json' }
          });

          const userData = response.data;

          // Persistir sesión
          localStorage.setItem("user",              JSON.stringify(userData));
          localStorage.setItem("rolId",             userData.rolId ?? 1);
          localStorage.setItem("administracionId",  userData.administracionId ?? 1);
          localStorage.setItem("administracionLogo", userData.administracionLogo || 'expensas360.png');
          localStorage.setItem("tipoAdministracion", userData.tipoAdministracion || 'Barrio Cerrado');
          localStorage.setItem("barriosPermitidos", JSON.stringify(userData.barriosPermitidos ?? []));

          const rolId   = userData.rolId ?? 1;
          const barrios = userData.barriosPermitidos ?? [];

          if (rolId === ROL_SUPERADMIN) {
              navigate("/liquidacionMensual");
          } else if (rolId === 1 || rolId === ROL_PERFIL_ADMINISTRADOR) {
              navigate("/dashboardGeneral");
          } else if (barrios.length === 0) {
              navigate("/tableBarrios");
          } else if (rolId === 3) {
              navigate("/dashboardPortero");
          } else {
              navigate("/portal");
          }
        } catch (err) {
          console.error('Error en login:', err);
          alert(err.response?.data?.message || 'Error al iniciar sesión');
        }
      }

    const handleChangeLogin = (e) => {
      setForm(
        {
          ...form,
          [e.target.name]: e.target.value
        }
      );

    }

    return (
      <>
        <Toast ref={toast} />
        <div className="login-body">
            <div className="login-image">
                <img src={`assets/layout/images/pages/login.jpg`} alt="Administración Barrios y Consorcios" />
            </div>
            <div className="login-panel p-fluid">
                <div className="flex flex-column">
                    <div className="flex align-items-center mb-6 logo-container">
                        <img src={`./assets/layout/images/ab/expensas360.png`} className="login-logo" alt="Administración Barrios" />
                    </div>
                    <div className="form-container">
                        <span className="p-input-icon-left">
                            <i className="pi pi-envelope"></i>
                            <InputText
                            type="text"
                            placeholder="Email"
                            id="user"
                            name="user"
                            label="Username"
                            onChange={ handleChangeLogin }
                            onKeyUp= { HandleClickEnter }
                            value={ form.user }
                            />
                        </span>
                        <span className="p-input-icon-left">
                            <i className="pi pi-key"></i>
                            <InputText
                            placeholder="Password"
                            id="password"
                            name="password"
                            label="Password"
                            type="password"
                            onChange={ handleChangeLogin }
                            value={ form.password }
                            onKeyUp= { HandleClickEnter }
                            />
                        </span>
                        <button className="flex p-link">Forgot your password?</button>
                    </div>
                    <div className="button-container">
                        <Button type="button" label="Login" onClick={ HandleClick } ></Button>
                        <span>
                            Don’t have an account?<button className="p-link">Sign-up here</button>
                        </span>
                    </div>
                </div>

                {/* <div className="login-footer flex align-items-center">
                    <div className="flex align-items-center login-footer-logo-container">
                        <img src="assets/layout/images/ab/logoab.png" className="login-footer-logo" alt="Administración Barrios" />
                    </div>
                    <span>Copyright { anioActual }</span>
                </div> */}
            </div>
        </div>
      </>
    );
};
